<template>
  <div class="fullpage">
    <StickyMenu />
    <SocialBar />
    <Home />
    <Projects :show-project-menu="showProjectMenu" sectionHeadlineProjects="Projects"/>
    <Profile sectionHeadlineProfile="Profile" sectionIntroProfile="15+ years of experience creating digital products" />
    <Contact sectionHeadlineContact="Contact" sectionIntroContact='Find me on <a href="https://www.linkedin.com/in/tobi-hoffmann-01967a189/" target="_blank">LinkedIn</a> and <a href="https://www.xing.com/profile/Tobias_Hoffmann19/cv" target="_blank">Xing</a> or write at <a id="copy-mail" data="click to copy">hi@tobihoffmann.com</a> Please call me Tobi.'/>
    </div>
  </template>

  <script>
  // @ is an alias to /src
  import StickyMenu from "@/components/StickyMenu.vue";
  import SocialBar from "@/components/SocialBar.vue";
  import Home from "@/components/Home.vue";
  import Projects from "@/components/Projects.vue";
  import Profile from "@/components/Profile.vue";
  import Contact from "@/components/Contact.vue";

  export default {
    name: "FullPage",
    data () {
      return {
        showProjectMenu: true,
      }
    },
    components: {
      StickyMenu,
      SocialBar,
      Home,
      Projects,
      Profile,
      Contact
    },
    beforeRouteLeave (to, from , next) {
      this.showProjectMenu = false;
      setTimeout(() => {
        next();
      }, 500);
    }
  };
  </script>